import moment from 'moment-timezone';

type MonthAndYear = {
  month: number;
  year: number;
};

export function getPreviousMonthWithYear(date: MonthAndYear): MonthAndYear {
  const prevMonthWithYear = moment.utc(date).subtract(1, 'month');

  return {
    year: prevMonthWithYear.year(),
    month: prevMonthWithYear.month(),
  };
}

export function getNextMonthWithYear(date: MonthAndYear): MonthAndYear {
  const nextMonthWithYear = moment.utc(date).add(1, 'month');

  return {
    year: nextMonthWithYear.year(),
    month: nextMonthWithYear.month(),
  };
}
